/*
 * Module for a select field which publishes when its value changes
*/
rs.module("controls/forms/dynamicform/dynamicfield",

    ["controls/forms/dynamicform"],

    function (dynamicForm) {

        //
        // Initialize
        //
        function initialize(formIdentifier, fieldId) {

            var dynamicFormInstance = dynamicForm.getForm(formIdentifier);

            // If there is no Id, there's nothing to do.
            if (!fieldId) {
                return;
            }

            var field = $.js(fieldId);

            // When this value changes, notify the form so dependent fields can be updated.
            field.change(function () {

                // Notify the form that this field has changed
                dynamicFormInstance.fieldChanged(fieldId, $(this).val());
            });

            // look for a checkbox which controls the enabled/disabled state
            field
                .closest('.form-group')
                .find(`:checkbox[data-selection-for='${fieldId}']`)
                .change(function () {
                    // toggle enabled/disabled state
                    $(field).prop('disabled', function (i, current) { return !current; })

                    // clear value
                    if ($(field).is(":checkbox")) {
                        $(field).setChecked(false);
                    }
                    else {
                        $(field).val('');
                    }
                });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);